import { render } from "./EditorContainer.vue?vue&type=template&id=23c735bd"
import script from "./EditorContainer.vue?vue&type=script&lang=js"
export * from "./EditorContainer.vue?vue&type=script&lang=js"

import "./EditorContainer.vue?vue&type=style&index=0&id=23c735bd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__